import React from "react";

import Row from "../../components/Row";
import Column from "../../components/Column";

import { titleCase } from "./stuffedFormat";
import { PRICE_SORT_OPTIONS, DATE_SORT_OPTIONS } from "./stuffedSort";
import { en, es } from "../../languages/langs";

// Orders arrive nested inside their class, so drilling down needs no
// second request.
const StuffedFilters = ({
  filters,
  classSlug,
  orderSlug,
  onChange,
  priceSort,
  dateSort,
  onSortChange,
  showPriceSort,
  activeLang,
}) => {
  const lang = { en, es }[activeLang];
  const classes = (filters && filters.classes) || [];
  const activeClass = classes.find((c) => c.common_name_slug === classSlug);
  const orders = activeClass ? activeClass.orders : [];

  const facetLabel = (facet) =>
    activeLang === "es"
      ? titleCase(facet.common_name_spanish || facet.common_name)
      : titleCase(facet.common_name);

  // The price control is absent for members whose region hides prices, so the
  // remaining three share the row rather than leaving a gap.
  const columnSize = showPriceSort ? "size__one-of-four" : "size__one-of-three";

  return (
    <Row extraClasses="m-bottom__large stuffed-filters">
      <Column
        extraClasses={`${columnSize} p-right__medium mobile-size__one-of-one`}
      >
        <label htmlFor="stuffed-class-filter" className="green-text">
          {lang["Filter by class"]}
        </label>
        <select
          id="stuffed-class-filter"
          data-testid="stuffed-class-filter"
          className="select--green"
          value={classSlug}
          onChange={(e) =>
            onChange({ classSlug: e.target.value, orderSlug: "" })
          }
        >
          <option value="">{`${lang["All classes"]} (${
            (filters && filters.total) || 0
          })`}</option>
          {classes.map((entry) => (
            <option key={entry.common_name_slug} value={entry.common_name_slug}>
              {`${facetLabel(entry)} (${entry.count})`}
            </option>
          ))}
        </select>
      </Column>
      <Column
        extraClasses={`${columnSize} p-right__medium mobile-size__one-of-one mobile-m-top__medium`}
      >
        <label htmlFor="stuffed-order-filter" className="green-text">
          {lang["Filter by order"]}
        </label>
        <select
          id="stuffed-order-filter"
          data-testid="stuffed-order-filter"
          className="select--green"
          value={orderSlug}
          disabled={!activeClass}
          onChange={(e) => onChange({ classSlug, orderSlug: e.target.value })}
        >
          <option value="">{`${lang["All orders"]}${
            activeClass ? ` (${activeClass.count})` : ""
          }`}</option>
          {orders.map((entry) => (
            <option key={entry.common_name_slug} value={entry.common_name_slug}>
              {`${facetLabel(entry)} (${entry.count})`}
            </option>
          ))}
        </select>
      </Column>
      {/* Price and date order independently: either, both, or neither.
          Whether the price control exists at all is decided upstream from
          `prices_visible`; this component only renders what it is handed. */}
      {showPriceSort && (
        <Column
          extraClasses={`${columnSize} p-right__medium mobile-size__one-of-one mobile-m-top__medium`}
        >
          <label htmlFor="stuffed-price-sort" className="green-text">
            {lang["Sort by price"]}
          </label>
          <select
            id="stuffed-price-sort"
            data-testid="stuffed-price-sort"
            className="select--green"
            value={priceSort}
            onChange={(e) => onSortChange({ priceSort: e.target.value })}
          >
            {PRICE_SORT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {lang[option.labelKey]}
              </option>
            ))}
          </select>
        </Column>
      )}
      <Column
        extraClasses={`${columnSize} mobile-size__one-of-one mobile-m-top__medium`}
      >
        <label htmlFor="stuffed-date-sort" className="green-text">
          {lang["Sort by date"]}
        </label>
        <select
          id="stuffed-date-sort"
          data-testid="stuffed-date-sort"
          className="select--green"
          value={dateSort}
          onChange={(e) => onSortChange({ dateSort: e.target.value })}
        >
          {DATE_SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {lang[option.labelKey]}
            </option>
          ))}
        </select>
      </Column>
    </Row>
  );
};

export default StuffedFilters;
